import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";

// My components
import UserNavbar from "./components/user/Navbar";
import AdminNavbar from "./components/admin/Navbar";
// import Footer from "./components/common/Footer";

// User Pages
import UserHome from "./routes/user/HomePage";
import UserLogin from "./routes/user/LoginPage";
import UserVerticals from "./routes/user/VerticalsPage";
import UserCourses from "./routes/user/CoursesPage";
import UserUnits from "./routes/user/UnitsPage";
import UserSingleUnit from "./routes/user/SingleUnitPage";
import UserResetPass from "./routes/user/ResetPassPage";
import UserRegis from "./routes/user/RegisPage";
import UserQuiz from "./routes/user/QuizPage";
import CertPage from "./routes/user/CertPage";
import UserDashBoard from "./routes/user/Dashboard";
import UserProfile from "./components/user/UserProfile";
import PrivacyPolicy from "./routes/user/PrivacyPolicy";
import SetPassword from "./routes/user/SetPassword.jsx";
import VerifyEmail from "./routes/user/VerifyEmail.jsx";

// Admin Pages
import AdminLogin from "./routes/admin/LoginPage";
import AdminServices from "./routes/admin/ServicesPage";
import AdminVerticals from "./routes/admin/VerticalsPage";
import AdminCourses from "./routes/admin/CoursesPage.jsx";
import AdminUnits from "./routes/admin/UnitsPage";
import AdminAddUnit from "./routes/admin/AddUnitPage";
import AdminUsers from "./routes/admin/AdminUsers.jsx";
import AdminMassEmail from "./routes/admin/MassEmailPage.jsx";
import AdminEmailHistory from "./routes/admin/EmailHistoryPage.jsx";
import SingleMouReport from "./routes/admin/SingleMouReport.jsx";
import YuvaEcRolesPage from "./routes/admin/YuvaEcRolesPage.jsx";
import AuditHistoryPage from "./routes/admin/AuditHistoryPage.jsx";
import ConfigurationPage from "./routes/admin/ConfigurationPage.jsx";
import HistoricalMoUPage from "./routes/admin/HistoricalMoUPage.jsx";
import DocumentationPage from "./routes/admin/DocumentationPage.jsx";

//instititute pages
import AddInstitute from "./routes/institute/AddInstitute.jsx";
import AllInstitute from "./routes/institute/AllInstitute.jsx";
import InstituteServicePage from "./routes/institute/ServicePage.jsx";
import InstituteStudents from "./routes/institute/InstituteStudents.jsx";
import InstituteProfile from "./routes/institute/InstituteProfile.jsx";
import InstituteAllStudents from "./routes/institute/InstituteAllStudents.jsx";
import AllMouList from "./routes/institute/AllMouList.jsx";

//chapterEM pages
import AddChapterEM from "./routes/chapterEM/AddChapterEM.jsx";
import EMservicePage from "./routes/chapterEM/ServicePage.jsx";
import AllChapterEM from "./routes/chapterEM/AllChapterEM.jsx";
import ChapterEMAllInstitutes from "./routes/chapterEM/AllInstitutes.jsx";
import EmProfile from "./routes/chapterEM/EmProfile.jsx";
import EmInstitute from "./components/admin/EmInstitute.jsx";
import EmMassEmail from "./routes/chapterEM/MassEmailPage.jsx";

//chapter
import AllChapter from "./routes/chapter/AllChapter.jsx";
import AddChapter from "./routes/chapter/AddChapter.jsx";
import RegionAll from "./routes/admin/RegionAll.jsx";
import StateAll from "./routes/admin/StateAll.jsx";
import CityAll from "./routes/admin/AllCities.jsx";
import AllRegionEM from "./routes/admin/AllRegionEM.jsx";
import AllTermsAndConditions from "./routes/admin/AllTermsAndConditions.jsx";
import AddTermsAndConditions from "./routes/admin/AddTermsAndConditions.jsx";
import EditTermsAndConditions from "./routes/admin/EditTermsAndConditions.jsx";
import AddRegionEM from "./routes/admin/AddRegionEM.jsx";
import RegionEMProfile from "./routes/admin/RegionEMProfile.jsx";

// Common Pages
import NotFound from "./routes/common/NotFound";
import UserAboutPage from "./routes/user/AboutPage";
import Footer from "./routes/user/Footer";
import AllUserLoginPage from "./routes/common/AllUserLoginPage.jsx";
import NewLoginPage from "./routes/common/NewLoginPage.jsx";
import YuvaLoginPage from "./routes/common/YuvaLoginPage.jsx";
import ThalirLoginPage from "./routes/common/ThalirLoginPage.jsx";
import AllUserVerifyEmail from "./routes/common/AllUserVerifyEmail.jsx";
import AllUserSetPwd from "./routes/common/AllUserSetPwd.jsx";
import SingleProfilePage from "./routes/common/SingleProfilePage.jsx";
// import NewLoginPage from "./routes/common/NewLoginPage.jsx"

import "./App.css";
import ScrollToTop from "./components/user/ScrollToTop";
import AdminUserPage from "./routes/admin/AdminUserPage.jsx";
import MouTypeDetails from "./routes/admin/MouTypePage.jsx";
import ChapterInstitutesDetails from "./routes/admin/ChapterInstitutesDetails.jsx";
import { UserTypeProvider } from "./routes/common/UserTypeContext.jsx";

function TitleManager() {
  const location = useLocation();

  useEffect(() => {
    const path = String(location.pathname || "").toLowerCase();

    // Landing page always shows org title
    if (path === "/") {
      document.title = "YOUNG INDIANS";
      return;
    }

    // Prefer explicit portalType saved at login; fallback to URL-based inference
    const storedPortalType = sessionStorage.getItem("portalType");
    const inferredPortalType = path.includes("thalir") ? "thalir" : "yuva";
    const portalType = storedPortalType || inferredPortalType;

    document.title = portalType === "thalir" ? "THALIR Portal" : "YUVA Portal";
  }, [location.pathname]);

  return null;
}

function FooterWrapper() {
  const location = useLocation();
  if (location.pathname === "/") return null; // landing has its own footer
  return <Footer />;
}

function App() {
  return (
    <UserTypeProvider>
      <Router>
        <ScrollToTop />
        <TitleManager />
        <div className="app-outer-div">
          <Routes>
            <Route
              exact
              path="/login"
              element={
                <>
                  <UserNavbar />
                  <AllUserLoginPage />
                </>
              }
            />
            <Route
              exact
              path="/login-new"
              element={
                <>
                  <UserNavbar />
                  <NewLoginPage />
                </>
              }
            />
            <Route
              exact
              path="/yuva-login"
              element={
                <>
                  <UserNavbar />
                  <YuvaLoginPage />
                </>
              }
            />
            <Route
              exact
              path="/thalir-login"
              element={
                <>
                  <UserNavbar />
                  <ThalirLoginPage />
                </>
              }
            />
            <Route
              path="/em-profile/:_id"
              element={
                <>
                  {" "}
                  <AdminNavbar />
                  <EmProfile />
                </>
              }
            />
            <Route
              path="/regionem-profile/:_id"
              element={
                <>
                  {" "}
                  <AdminNavbar />
                  <RegionEMProfile />
                </>
              }
            />
            <Route
              path="/institute-profile/:_id"
              element={
                <>
                  {" "}
                  <UserNavbar />
                  <InstituteProfile />
                </>
              }
            />
            <Route
              path="/institute-students/:_id"
              element={
                <>
                  {" "}
                  <UserNavbar />
                  <InstituteAllStudents />
                </>
              }
            />
            <Route
              path="/admin/institute-profile/:_id"
              element={
                <>
                  {" "}
                  <AdminNavbar />
                  <InstituteProfile />
                </>
              }
            />
            <Route
              path="/admin/institute-students/:_id"
              element={
                <>
                  {" "}
                  <AdminNavbar />
                  <InstituteAllStudents />
                </>
              }
            />
            <Route
              path="/admin/yuva-ec-roles"
              element={
                <>
                  <AdminNavbar />
                  <YuvaEcRolesPage />
                </>
              }
            />
            <Route
              path="/em-institutes/:_id"
              element={
                <>
                  {" "}
                  <AdminNavbar />
                  <EmInstitute />
                </>
              }
            />
            {/* <Route
                            exact
                            path="/new-login"


                            element={
                                <>
                                    <UserNavbar />
                                    <NewLoginPage />
                                </>
                            }
                        /> */}
            {/* <Route
                        exact
                        path="/user/login"
                        element={
                            <>
                                <UserNavbar />
                                <UserLogin />
                            </>
                        }
                    /> */}
            <Route
              path="/institute/students/all"
              element={
                <>
                  <UserNavbar />
                  <InstituteStudents />
                </>
              }
            />
            <Route
              path="/admin/institute/mou/all/:_id"
              element={
                <>
                  <AdminNavbar />
                  <AllMouList />
                </>
              }
            />
            <Route
              exact
              path="/region/mou-details"
              element={
                <>
                  <AdminNavbar />
                  <MouTypeDetails />
                </>
              }
            />
            <Route
              exact
              path="/region/institutes-details"
              element={
                <>
                  <AdminNavbar />
                  <ChapterInstitutesDetails />
                </>
              }
            />

            <Route
              path="/institute/mou/all/:_id"
              element={
                <>
                  <UserNavbar />
                  <AllMouList />
                </>
              }
            />
            <Route
              exact
              path="/region/all"
              element={
                <>
                  <AdminNavbar />
                  <RegionAll />
                </>
              }
            />
            <Route
              exact
              path="/state/all"
              element={
                <>
                  <AdminNavbar />
                  <StateAll />
                </>
              }
            />
            <Route
              exact
              path="/city/all"
              element={
                <>
                  <AdminNavbar />
                  <CityAll />
                </>
              }
            />
            <Route
              exact
              path="/region-em/all"
              element={
                <>
                  <AdminNavbar />
                  <AllRegionEM />
                </>
              }
            />
            <Route
              exact
              path="/region-em/add"
              element={
                <>
                  <AdminNavbar />
                  <AddRegionEM />
                </>
              }
            />
            <Route
              exact
              path="/terms-conditions/all"
              element={
                <>
                  <AdminNavbar />
                  <AllTermsAndConditions />
                </>
              }
            />
            <Route
              exact
              path="/terms-conditions/add"
              element={
                <>
                  <AdminNavbar />
                  <AddTermsAndConditions />
                </>
              }
            />
            <Route
              exact
              path="/terms-conditions/edit/:id"
              element={
                <>
                  <AdminNavbar />
                  <EditTermsAndConditions />
                </>
              }
            />
            <Route
              exact
              path="/region-em/edit/:userId"
              element={
                <>
                  <AdminNavbar />
                  <AddRegionEM />
                </>
              }
            />

            <Route
              exact
              path="/institute/services"
              element={
                <>
                  <UserNavbar />
                  <InstituteServicePage />
                </>
              }
            />
            <Route
              exact
              path="/em/institute/all"
              element={
                <>
                  <AdminNavbar />
                  <ChapterEMAllInstitutes />
                </>
              }
            />
            <Route
              exact
              path="/em/all"
              element={
                <>
                  <AdminNavbar />
                  <AllChapterEM />
                </>
              }
            />
            <Route
              exact
              path="/chapter/all"
              element={
                <>
                  <AdminNavbar />
                  <AllChapter />
                </>
              }
            />
            <Route
              exact
              path="/em/services"
              element={
                <>
                  <AdminNavbar />
                  <EMservicePage />
                </>
              }
            />
            <Route
              path="/em/mass-email"
              element={
                <>
                  <AdminNavbar />
                  <EmMassEmail />
                </>
              }
            />
            <Route
              path="/em/email-history"
              element={
                <>
                  <AdminNavbar />
                  <AdminEmailHistory />
                </>
              }
            />
            <Route
              exact
              path="/verify-email"
              element={
                <>
                  <UserNavbar />
                  <AllUserVerifyEmail />
                </>
              }
            />
            <Route
              exact
              path="/set-password"
              element={
                <>
                  <UserNavbar />
                  <AllUserSetPwd />
                </>
              }
            />
            <Route
              exact
              path="/profile"
              element={
                <>
                  <UserNavbar />
                  <SingleProfilePage />
                </>
              }
            />
            <Route
              exact
              path="/institutes/insert"
              element={
                <>
                  <AdminNavbar />
                  <AddInstitute />
                </>
              }
            />
            <Route
              exact
              path="/institutes/all"
              element={
                <>
                  <AdminNavbar />
                  <AllInstitute />
                </>
              }
            />
            <Route
              exact
              path="/user/set-password"
              element={
                <>
                  <UserNavbar />
                  <SetPassword />
                </>
              }
            />
            <Route
              exact
              path="/user/verify-email"
              element={
                <>
                  <UserNavbar />
                  <VerifyEmail />
                </>
              }
            />
            <Route
              exact
              path="/ems/insert"
              element={
                <>
                  <AdminNavbar />
                  <AddChapterEM />
                </>
              }
            />
            <Route
              exact
              path="/admin/chapter/insert"
              element={
                <>
                  <AdminNavbar />
                  <AddChapter />
                </>
              }
            />
            <Route
              exact
              path="/ems/all"
              element={
                <>
                  <AdminNavbar />
                  <AddChapterEM />
                </>
              }
            />
            <Route
              exact
              path="/"
              element={
                <>
                  <UserHome />
                </>
              }
            />
            <Route
              exact
              path="/about"
              element={
                <>
                  <UserNavbar />
                  <UserAboutPage />
                </>
              }
            />
            <Route
              exact
              path="/admin/about"
              element={
                <>
                  <AdminNavbar />
                  <UserAboutPage />
                </>
              }
            />
            <Route
              exact
              path="/em/about"
              element={
                <>
                  <AdminNavbar />
                  <UserAboutPage />
                </>
              }
            />
            <Route
              exact
              path="/institute/about"
              element={
                <>
                  <UserNavbar />
                  <UserAboutPage />
                </>
              }
            />
            <Route
              exact
              path="/student/about"
              element={
                <>
                  <UserNavbar />
                  <UserAboutPage />
                </>
              }
            />
            <Route
              exact
              path="/privacy-policy"
              element={
                <>
                  <UserNavbar />
                  <PrivacyPolicy />
                </>
              }
            />
            <Route
              exact
              path="/privacyPolicy"
              element={
                <>
                  <AdminNavbar />
                  <PrivacyPolicy />
                </>
              }
            />
            <Route
              exact
              path="/user/profile"
              element={
                <>
                  <UserNavbar />
                  <UserProfile />
                </>
              }
            />
            <Route
              exact
              path="/user/verticals/all"
              element={
                <>
                  <UserNavbar />
                  <UserVerticals />
                </>
              }
            />
            <Route
              exact
              path="/user/verticals/:verticalId/courses/all"
              element={
                <>
                  <UserNavbar />
                  <UserCourses />
                </>
              }
            />
            <Route
              exact
              path="/user/verticals/:verticalId/courses/:courseId/units/all"
              element={
                <>
                  <UserNavbar />
                  <UserUnits />
                </>
              }
            />
            <Route
              exact
              path="/user/verticals/:verticalId/courses/:courseId/units/:unitId"
              element={
                <>
                  <UserNavbar />
                  <UserSingleUnit />
                </>
              }
            />
            <Route
              exact
              path="/user/verticals/:verticalId/courses/:courseId/units/:unitId/quiz"
              element={
                <>
                  <UserNavbar />
                  <UserQuiz />
                </>
              }
            />
            <Route
              exact
              path="/user/reset-password"
              element={
                <>
                  <UserNavbar />
                  <UserResetPass />
                </>
              }
            />

            <Route
              exact
              path="/user/register/:_id"
              element={
                <>
                  <UserNavbar />
                  <UserRegis />
                </>
              }
            />

            <Route
              exact
              path="/user/certificate/:certId"
              element={
                <>
                  <UserNavbar />
                  <CertPage />
                </>
              }
            />
            <Route
              exact
              path="/user/dashboard"
              element={
                <>
                  <UserNavbar />
                  <UserDashBoard />
                </>
              }
            />
            <Route
              path="/admin/services"
              element={
                <>
                  <AdminNavbar />
                  <AdminServices />
                </>
              }
            />
            <Route
              path="/admin/documentation"
              element={
                <>
                  <AdminNavbar />
                  <DocumentationPage />
                </>
              }
            />
            <Route
              path="/documentation"
              element={
                <>
                  <AdminNavbar />
                  <DocumentationPage />
                </>
              }
            />
            <Route
              path="/admin/courses"
              element={
                <>
                  <AdminCourses />
                  <AdminNavbar />
                </>
              }
            />
            <Route
              path={"/admin/login"}
              element={
                <>
                  <AdminNavbar />
                  <AdminLogin />
                </>
              }
            />
            <Route
              path="/admin/verticals/all"
              element={
                <>
                  <AdminNavbar />
                  <AdminVerticals />
                </>
              }
            />
            <Route
              path="/admin/users/all"
              element={
                <>
                  <AdminNavbar />
                  <AdminUsers />
                </>
              }
            />
            <Route
              path="/admin/users/:userId"
              element={
                <>
                  <AdminNavbar />
                  <AdminUserPage />
                </>
              }
            />
            <Route
              path="/admin/mass-email"
              element={
                <>
                  <AdminNavbar />
                  <AdminMassEmail />
                </>
              }
            />

            <Route
              path="/admin/email-history"
              element={
                <>
                  <AdminNavbar />
                  <AdminEmailHistory />
                </>
              }
            />
            <Route
              path="/admin/audit-history"
              element={
                <>
                  <AdminNavbar />
                  <AuditHistoryPage />
                </>
              }
            />
            <Route
              path="/admin/historical-mou"
              element={
                <>
                  <AdminNavbar />
                  <HistoricalMoUPage />
                </>
              }
            />
            <Route
              path="/admin/configuration"
              element={
                <>
                  <AdminNavbar />
                  <ConfigurationPage />
                </>
              }
            />
            <Route
              path="/admin/reports/single-mou"
              element={
                <>
                  <AdminNavbar />
                  <SingleMouReport />
                </>
              }
            />
            <Route
              path="/admin/verticals/:verticalId/courses/all"
              element={
                <>
                  <AdminNavbar />
                  <AdminCourses />
                </>
              }
            />
            <Route
              path="/admin/verticals/:verticalId/courses/:courseId/units/all"
              element={
                <>
                  <AdminNavbar />
                  <AdminUnits />
                </>
              }
            />
            <Route
              path="/admin/verticals/:verticalId/courses/:courseId/units/add"
              element={
                <>
                  <AdminNavbar />
                  <AdminAddUnit />
                </>
              }
            />
            <Route
              exact
              path="/user/resource-not-found"
              element={
                <>
                  <UserNavbar />
                  <NotFound />
                </>
              }
            />

            <Route
              exact
              path="/admin/resource-not-found"
              element={
                <>
                  <AdminNavbar />
                  <NotFound />
                </>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>

        <FooterWrapper />

        <Toaster
          toastOptions={{
            duration: 3000,
            style: {
              fontFamily: "var(--font-family-2)",
              marginTop: "2rem",
            },
          }}
        />
      </Router>
    </UserTypeProvider>
  );
}

export default App;
